// Inline icon set — ported from workday-poc icons.jsx (window global → ESM)
export function Icon({ name, size = 16, color = "currentColor", strokeWidth = 1.6, style }) {
  const s = { width: size, height: size, color, ...style };
  const sw = strokeWidth;
  switch (name) {
    case "menu":
      return (
        <svg
          style={s}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={sw}
          strokeLinecap="round"
        >
          <path d="M4 7h16M4 12h16M4 17h16" />
        </svg>
      );
    case "search":
      return (
        <svg
          style={s}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={sw}
          strokeLinecap="round"
        >
          <circle cx="11" cy="11" r="7" />
          <path d="M20 20l-3.5-3.5" />
        </svg>
      );
    case "sparkle":
      return (
        <svg style={s} viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2.5l1.6 5.2a4 4 0 002.7 2.7L21.5 12l-5.2 1.6a4 4 0 00-2.7 2.7L12 21.5l-1.6-5.2a4 4 0 00-2.7-2.7L2.5 12l5.2-1.6a4 4 0 002.7-2.7L12 2.5z" />
        </svg>
      );
    case "bell":
      return (
        <svg
          style={s}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={sw}
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M6 9a6 6 0 1112 0c0 5 2 7 2 7H4s2-2 2-7z" />
          <path d="M10 19a2 2 0 004 0" />
        </svg>
      );
    case "inbox":
      return (
        <svg
          style={s}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={sw}
          strokeLinejoin="round"
        >
          <path d="M3 12l3-7h12l3 7" />
          <path d="M3 12v6h18v-6" />
          <path d="M3 12h5l1 2h6l1-2h5" />
        </svg>
      );
    case "chev-down":
      return (
        <svg
          style={s}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={sw}
          strokeLinecap="round"
        >
          <path d="M6 9l6 6 6-6" />
        </svg>
      );
    case "chev-right":
      return (
        <svg
          style={s}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={sw}
          strokeLinecap="round"
        >
          <path d="M9 6l6 6-6 6" />
        </svg>
      );
    case "chev-left":
      return (
        <svg
          style={s}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={sw}
          strokeLinecap="round"
        >
          <path d="M15 6l-6 6 6 6" />
        </svg>
      );
    case "check":
      return (
        <svg
          style={s}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M5 12l5 5L20 7" />
        </svg>
      );
    case "external":
      return (
        <svg
          style={s}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={sw}
          strokeLinecap="round"
        >
          <path d="M14 4h6v6" />
          <path d="M20 4L11 13" />
          <path d="M19 14v5a1 1 0 01-1 1H5a1 1 0 01-1-1V6a1 1 0 011-1h5" />
        </svg>
      );
    case "shield":
      return (
        <svg
          style={s}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={sw}
          strokeLinejoin="round"
        >
          <path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6l8-3z" />
        </svg>
      );
    case "doc":
      return (
        <svg
          style={s}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={sw}
          strokeLinejoin="round"
        >
          <path d="M6 3h8l4 4v14H6z" />
          <path d="M14 3v4h4" />
        </svg>
      );
    case "play":
      return (
        <svg style={s} viewBox="0 0 24 24" fill="currentColor">
          <path d="M7 5v14l11-7z" />
        </svg>
      );
    case "note":
      return (
        <svg
          style={s}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={sw}
          strokeLinejoin="round"
        >
          <path d="M5 4h10l4 4v12H5z" />
          <path d="M9 13h6M9 17h4" />
        </svg>
      );
    case "user":
      return (
        <svg
          style={s}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={sw}
          strokeLinecap="round"
        >
          <circle cx="12" cy="8" r="3.5" />
          <path d="M5 20c1-3.5 4-5 7-5s6 1.5 7 5" />
        </svg>
      );
    case "list":
      return (
        <svg
          style={s}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={sw}
          strokeLinecap="round"
        >
          <path d="M8 6h12M8 12h12M8 18h12" />
          <circle cx="4" cy="6" r="1" />
          <circle cx="4" cy="12" r="1" />
          <circle cx="4" cy="18" r="1" />
        </svg>
      );
    case "lock":
      return (
        <svg
          style={s}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={sw}
          strokeLinejoin="round"
        >
          <rect x="5" y="11" width="14" height="9" rx="2" />
          <path d="M8 11V8a4 4 0 018 0v3" />
        </svg>
      );
    case "plus":
      return (
        <svg
          style={s}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
        >
          <path d="M12 5v14M5 12h14" />
        </svg>
      );
    case "info":
      return (
        <svg
          style={s}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={sw}
          strokeLinecap="round"
        >
          <circle cx="12" cy="12" r="9" />
          <path d="M12 11v6" />
          <path d="M12 7.5h.01" />
        </svg>
      );
    case "diagram":
      return (
        <svg
          style={s}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={sw}
          strokeLinejoin="round"
        >
          <rect x="3" y="3" width="6" height="5" />
          <rect x="15" y="3" width="6" height="5" />
          <rect x="3" y="16" width="6" height="5" />
          <rect x="15" y="16" width="6" height="5" />
          <path d="M9 5.5h6M9 18.5h6M6 8v8M18 8v8" />
        </svg>
      );
    default:
      return null;
  }
}
